import React, { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import PageTitle from '../../components/stateless/PageTitle';
import IconCard from '../../components/stateless/IconCard';

import { SolutionsList } from '../../constants';

import './index.scss';

function Solutions() {
  const solutionId = window.location.hash.split('#')[1];

  const history = useHistory();

  const [solutionSlug, setSolutionSlug] = useState(solutionId || '');
  const [sections, setSections] = useState([]);

  useEffect(() => {
    setSolutionSlug(solutionId);
    solutionId ? window.location.href = '#' + solutionId : history.push(`/not-found`);
  }, [solutionId]);

  useEffect(() => {
    setSections(document.querySelectorAll('section.section-anchor'));
  }, []);

  const handleScroll = useCallback((e) => {
    let scrollY = window.pageYOffset;

    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop;
      const sectionId = current.getAttribute("id");

      if (
        scrollY > sectionTop &&
        scrollY <= (sectionTop + sectionHeight)
      ) {
        setSolutionSlug(sectionId);
      }
      if (scrollY === 0) {
        setSolutionSlug(null);
      }
    })
  }, [sections]);

  window.addEventListener('scroll', handleScroll);

  return (
    <>
      <PageTitle
        isSolution={false}
        heading="Solutions"
        description="BetConstruct offers 3 solution types for
				 creating and launching your iGaming operation via the SpringBME console: White Label, Turnkey and API."/>
      <div className="solutions-content-wrapper">
        <div className="container-layout">
          <div className="solutions-container">
            <nav className="solutions-content-menu">
              {
                SolutionsList.map(item =>

                  <a href={`#${item.slug}`} className="solutions-content-menu-inner" key={item.slug}
                     onClick={() => setSolutionSlug(item.slug)}>
                    <label htmlFor={item.slug + 'contentMenuITem'}
                           className={item.slug === solutionSlug ? 'text-selected' : ''}>{item.name}</label>
                  </a>
                )
              }
            </nav>
            <div className="content-item">
              {
                SolutionsList.map(solution => {
                  return (
                    <section id={solution.slug} key={solution.slug} className="section-anchor">
                      <p className="solutions-menu-title">{solution.name}</p>
                      <p className="solutions-menu-t-txt">{solution.description}</p>
                      {
                        solution.nestedSubMenu?.products &&
                        <>
                          <p className="solutions-menu-title">Products</p>
                          <div className="solutions-menu-inner">
                            {
                              solution.nestedSubMenu?.products.map(nestedSubItem =>
                                <Link to={'/' + nestedSubItem.path}>
                                  <div className="solutions-menu-i-row" key={nestedSubItem.name}>
                                    <div className="solutions-menu-i-top">
                                      <IconCard size="small" bgGray={false} icon={nestedSubItem.icon}/>
                                      <p className="text-capitalize">{nestedSubItem.name}</p>
                                    </div>
                                    <p className="solutions-menu-i-txt">{nestedSubItem.description}</p>
                                  </div>
                                </Link>
                              )
                            }
                          </div>
                        </>
                      }
                      {
                        solution.nestedSubMenu?.tools &&
                        <>
                          <p className="solutions-menu-title">Tools</p>
                          <div className="solutions-menu-inner">
                            {
                              solution.nestedSubMenu?.tools.map(nestedSubItem =>
                                <Link to={'/' + nestedSubItem.path}>
                                  <div className="solutions-menu-i-row" key={nestedSubItem.name}>
                                    <div className="solutions-menu-i-top">
                                      <IconCard size="small" bgGray={false} icon={nestedSubItem.icon}/>
                                      <p className="text-capitalize">{nestedSubItem.name}</p>
                                    </div>
                                    <p className="solutions-menu-i-txt">{nestedSubItem.description}</p>
                                  </div>
                                </Link>
                              )
                            }
                          </div>
                        </>
                      }
                      {
                        solution.nestedSubMenu?.payments &&
                        <>
                          <p className="solutions-menu-title">Payments</p>
                          <div className="solutions-menu-inner">
                            {
                              solution.nestedSubMenu?.payments.map(nestedSubItem =>
                                <Link to={'/' + nestedSubItem.path}>
                                  <div className="solutions-menu-i-row" key={nestedSubItem.name}>
                                    <div className="solutions-menu-i-top">
                                      <IconCard size="small" bgGray={false} icon={nestedSubItem.icon}/>
                                      <p className="text-capitalize">{nestedSubItem.name}</p>
                                    </div>
                                    <p className="solutions-menu-i-txt">{nestedSubItem.description}</p>
                                  </div>
                                </Link>
                              )
                            }
                          </div>
                        </>
                      }
                    </section>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Solutions;
